/**
 * Companies Service - Irrigo Platform
 * Servicio para gestión de empresas
 */

import { api, ApiResponse, PaginatedResponse, PaginationParams } from './api';
import type { 
  ApiCompany, 
  CreateCompanyRequest, 
  UpdateCompanyRequest 
} from '@/types/api';

// ============================================================================
// COMPANIES SERVICE
// ============================================================================

export interface CompanyFilters extends PaginationParams {
  search?: string;
}

export const companiesService = {
  /**
   * Listar todas las empresas
   */
  async getAll(params?: CompanyFilters): Promise<PaginatedResponse<ApiCompany>> {
    return api.getPaginated<ApiCompany>('/companies', params);
  },

  /**
   * Obtener empresa por ID
   */
  async getById(id: string): Promise<ApiResponse<ApiCompany>> {
    return api.get<ApiCompany>(`/companies/${id}`);
  },

  /**
   * Crear nueva empresa
   */
  async create(data: CreateCompanyRequest): Promise<ApiResponse<ApiCompany>> {
    return api.post<ApiCompany>('/companies', data);
  },

  /**
   * Actualizar empresa
   */
  async update(id: string, data: UpdateCompanyRequest): Promise<ApiResponse<ApiCompany>> {
    return api.put<ApiCompany>(`/companies/${id}`, data);
  },

  /**
   * Eliminar empresa
   */
  async delete(id: string): Promise<ApiResponse<{ message: string }>> {
    return api.delete<{ message: string }>(`/companies/${id}`);
  },
};

export default companiesService;
